import React, { useState } from 'react';
import {Link} from 'react-router-dom';
import "./login.css";



const Login = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form data:', formData);
  };

  return (
    <div className='from'>
    <div className="login">
        
        <h2><b>Login  Form</b></h2>

      <form onSubmit={handleSubmit}>
        
        <div className="form-group">
        <i class="bi bi-person-fill"></i><label htmlFor="email"></label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
        <i class="bi bi-lock-fill"></i><label htmlFor="password"></label>
          <input
            type="password"
            id="password"
            name="password"
            value={formData.password}
            onChange={handleChange}
            required
            
          />
        </div>
        <button type="submit">Login</button>
      </form>
      <Link to="/login"></Link>
    </div></div>
  );
};

export default Login;
